import { css } from "@emotion/react";

export const style = height => css`
  padding-top: ${height}px !important;
`;
